import { render, staticRenderFns } from "./AdminSearchWrapper.vue?vue&type=template&id=681ac1a9&scoped=true&"
import script from "./AdminSearchWrapper.vue?vue&type=script&lang=js&"
export * from "./AdminSearchWrapper.vue?vue&type=script&lang=js&"
import style0 from "./AdminSearchWrapper.vue?vue&type=style&index=0&id=681ac1a9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "681ac1a9",
  null
  
)

export default component.exports